import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope, FaTimes } from "react-icons/fa";
import logo1 from "../../img/optionbricks_logo.png"; // Ensure your logo path is correct

const Header = () => {
  const [showTopbar, setShowTopbar] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [mounted, setMounted] = useState(false);

  const menuItems = ["Home", "About", "Contact", "User Consent", "Service Offerings"];

  const hrefFor = (item) =>
    item === "Home" ? "/" : `/${item.toLowerCase().replace(/\s+/g, "-")}`;

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    // trigger entrance animation after mount
    const t = setTimeout(() => setMounted(true), 50);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(t);
    };
  }, []);

  return (
    <header className="relative w-full z-[50]   ">

      {/* ==================== TOP BAR ==================== */}
      <div
        className={`fixed top-0 left-0 w-full bg-[#1e6091] text-white z-[51] transition-all duration-500 ease-in-out overflow-hidden flex items-center ${
          showTopbar ? "h-9 opacity-100" : "h-0 opacity-0"
        }`}
      >
        <div className="container mx-auto px-6 md:px-8 lg:px-12 w-full flex justify-between items-center text-xs sm:text-sm font-medium tracking-wide">

          {/* Left Side: Trust Indicator */}
          <div className="flex items-center gap-2 text-white">
            <span className="hidden sm:inline-flex items-center gap-2 font-semibold">
              
              
            </span>
          </div>

          {/* Right Side: Contact Info & Close Button */}
          <div className="flex items-center gap-5 sm:gap-8 text-white">
            <a
              href="mailto:compliance@optionbricks.in"
              className="hidden md:flex items-center gap-2 hover:text-[#43a9a8] transition-colors text-white"
            >
              <FaEnvelope className="text-[#43a9a8]" /> compliance@optionbricks.in
            </a>
            <a
              href="tel:+919082280240"
              className="flex items-center gap-2 hover:text-[#43a9a8] transition-colors font-semibold text-white"
            >
              <FaPhoneAlt className="text-[#43a9a8]" /> +91 90822 80240
            </a>

            <button
              onClick={() => setShowTopbar(false)}
              className="text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 ml-2"
              aria-label="Close Top Bar"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      </div>

      {/* ==================== MAIN NAVBAR ==================== */}
      <nav
        className={`fixed left-0 w-full font-sans z-[50] transition-all duration-500 ease-in-out ${
          showTopbar ? "top-9" : "top-0"
        } ${
          hasScrolled || isOpen
            ? "bg-white/90 backdrop-blur-xl border-b border-zinc-200/60 shadow-[0_8px_30px_rgba(0,0,0,0.06)] py-2"
            : "bg-white py-3.5"
        }`}
        style={{
          transform: mounted ? "translateY(0)" : "translateY(-100%)",
          opacity: mounted ? 1 : 0,
          transitionProperty: "transform, opacity, padding, background-color, box-shadow",
        }}
      >
        <div className="container mx-auto flex justify-between items-center px-6 md:px-8 lg:px-12">

          {/* Logo */}
          <a
            href="/"
            className="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.03]"
            style={{
              opacity: mounted ? 1 : 0,
              transform: mounted ? "translateY(0)" : "translateY(-10px)",
              transition: "all 0.6s cubic-bezier(0.16,1,0.3,1) 0.1s",
            }}
          >
            <img
              src={logo1}
              alt="Option Bricks"
              className={`h-auto object-contain drop-shadow-sm transition-all duration-500 ${
                hasScrolled
                  ? "max-w-[115px] md:max-w-[130px]"
                  : "max-w-[130px] md:max-w-[150px]"
              }`}
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-1 text-[15px] font-semibold text-zinc-700">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={hrefFor(item)}
                className="relative group px-4 py-2 rounded-full transition-colors duration-300 hover:text-[#1e6091] hover:bg-[#1e6091]/[0.06]"
                style={{
                  opacity: mounted ? 1 : 0,
                  transform: mounted ? "translateY(0)" : "translateY(-10px)",
                  transition: `all 0.5s cubic-bezier(0.16,1,0.3,1) ${0.15 + index * 0.07}s`,
                }}
              >
                {item}
                <span className="absolute left-1/2 -translate-x-1/2 -bottom-0.5 w-0 h-[2px] rounded-full bg-[#1e6091] transition-all duration-300 group-hover:w-1/2"></span>
              </a>
            ))}
          </div>

          {/* Desktop CTA Button */}
          

          {/* Mobile Hamburger */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden relative z-50 p-2 text-zinc-800 hover:text-[#1e6091] focus:outline-none transition-colors duration-300"
          >
            <div className="w-6 flex flex-col items-end gap-1.5">
              <span className={`h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? 'w-6 rotate-45 translate-y-2' : 'w-6'}`}></span>
              <span className={`h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? 'opacity-0' : 'w-4'}`}></span>
              <span className={`h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? 'w-6 -rotate-45 -translate-y-2' : 'w-5'}`}></span>
            </div>
          </button>
        </div>

        {/* ==================== MOBILE MENU DROPDOWN ==================== */}
        <div
          className={`lg:hidden absolute top-full left-0 w-full bg-white/95 backdrop-blur-xl shadow-2xl overflow-hidden transition-all duration-500 ease-in-out ${
            isOpen ? "max-h-[500px] border-t border-zinc-100" : "max-h-0"
          }`}
        >
          <div className="flex flex-col px-6 py-4 space-y-1">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={hrefFor(item)}
                onClick={() => setIsOpen(false)}
                className="w-full text-zinc-700 font-semibold text-lg py-3 border-b border-zinc-100 hover:text-[#1e6091] hover:pl-2 transition-all duration-300"
                style={{
                  opacity: isOpen ? 1 : 0,
                  transform: isOpen ? "translateX(0)" : "translateX(-12px)",
                  transition: `all 0.4s ease-out ${index * 0.06}s`,
                }}
              >
                {item}
              </a>
            ))}

            {/* Mobile CTA Button */}
            {/* <a
              href="https://wa.me/+919082280240"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="mt-6 w-full flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl text-white font-bold bg-[#1e6091] shadow-[0_8px_20px_rgba(30,96,145,0.25)] active:scale-[0.98] transition-all"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Request Live Demo
            </a> */}
          </div>
        </div>
      </nav>

      {/* Global CSS for the Shimmer Animation */}
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </header>
  );
};

export default Header;
